<template>
  <div id="L1" class="sub">
    <div class="wrapper">
      <kg-header :headerType=0 />
      <div id="content">
        <div class="inner_static">
          <h1 class="tit1">パスワードを忘れた方</h1>
          <div class="vm_wrap">
            <div class="inner_static">
              <h2 class="ins_tit">メールの送信が完了しました。</h2>
              <p class="ins_lead">
                入力いただいたメールアドレスに、パスワード再設定ページへのリンクを記載したメールをお送りしました。URLの有効期限は24時間となりますので、ご注意ください。<br><br>
                メールを受け取れない場合は、迷惑メールボックスの設定解除、〇〇.jpからのドメイン着信許可の設定をご確認ください。
              </p>
            </div>
          </div>
          <div class="fixed_btn_area">
            <div class="inner_static">
              <a class="btn1" @click="btnTopClick()">TOPへ</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
// kagull Module
import Header from '../components/common/HomeIconHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  methods: {
    btnTopClick: function () {
      this.$router.push('/kagull/login')
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/PasswordResetMailConfirm.vue